import { createUseStyles } from "react-jss"
import { textSize } from '@portal/kit/pkg/styles'

export default createUseStyles(theme => ({
  linkItem: {
    display: 'block',
    fontStyle: 'italic',
    color: theme.main_color,
    ...textSize(14, 32),
    '& span': {
      textDecoration: 'underline'
    },
    '&:hover': {
      opacity: '.75'
    },
    '&:before': {
      marginRight: 4,
      content: '"•"'
    }
  }
}))
